import React from "react";
import { MessageCircle } from "lucide-react";
import { COMPANY } from "@/data/site";

export default function WhatsAppButton() {
  return (
    <a
      href={`https://wa.me/${COMPANY.whatsapp}?text=Hello%20VPS%20team%2C%20I%27d%20like%20to%20enquire%20about%20your%20services.`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="whatsapp-float-btn"
      className="fixed bottom-6 right-6 z-50 bg-[#25d366] text-white p-4 rounded-full shadow-lg hover:scale-110 transition-transform vps-pulse flex items-center justify-center"
      aria-label="Chat on WhatsApp"
    >
      <MessageCircle size={24} />
    </a>
  );
}
